import React from 'react';
import { Card, Box, Typography, Stack, LinearProgress, alpha, useTheme } from '@mui/material';

const COLORS = ['#FE5F01', '#3B82F6', '#10B981', '#F59E0B', '#8B5CF6', '#EC4899', '#06B6D4', '#64748B'];

const fmt = (n) => Number(n || 0).toLocaleString('en-IN');

const HorizontalBarCard = ({
  title,
  subtitle,
  data = [],
  max,
  valueKey = 'count',
  labelKey = 'name',
}) => {
  const theme = useTheme();
  const peak = max || Math.max(1, ...data.map((d) => d[valueKey] || 0));
  return (
    <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 4, height: '100%', width: '100%', maxWidth: '100%' }}>
      <Box mb={2}>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>{title}</Typography>
        {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
      </Box>
      <Stack spacing={2}>
        {data.length === 0 && (
          <Box sx={{ py: 4, textAlign: 'center' }}>
            <Typography color="text.secondary">No data</Typography>
          </Box>
        )}
        {data.map((d, i) => {
          const v = d[valueKey] || 0;
          const pct = (v / peak) * 100;
          const color = COLORS[i % COLORS.length];
          return (
            <Box key={d[labelKey] + i}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1, minWidth: 0 }}>
                  <Box
                    sx={{
                      width: 22,
                      height: 22,
                      borderRadius: 1,
                      bgcolor: alpha(color, 0.15),
                      color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 11,
                      fontWeight: 800,
                      flexShrink: 0,
                    }}
                  >
                    {i + 1}
                  </Box>
                  <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
                    {d[labelKey]}
                  </Typography>
                </Stack>
                <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.primary' }}>
                  {fmt(v)}
                </Typography>
              </Stack>
              <LinearProgress
                variant="determinate"
                value={pct}
                sx={{
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: alpha(theme.palette.grey[400], 0.18),
                  '& .MuiLinearProgress-bar': {
                    background: `linear-gradient(90deg, ${color} 0%, ${alpha(color, 0.7)} 100%)`,
                    borderRadius: 4,
                  },
                }}
              />
            </Box>
          );
        })}
      </Stack>
    </Card>
  );
};

export default React.memo(HorizontalBarCard);
